export enum BOOKING_REFUND_SOURCE {
  HOTEL = 'HOTEL',
  STAYCATION = 'STAYCATION',
}

export type BookingRefundSource =
  (typeof BOOKING_REFUND_SOURCE)[keyof typeof BOOKING_REFUND_SOURCE];
